import React, { Component } from 'react';

class Organisation extends Component {
    // constructor(args) {
    //     super(args);
    //     console.log(args.match.params.orgId);
    // };

    render = () => {
        return (
            <div>Org: {this.props.match.params.orgID}</div>
        )
    };
};

export default Organisation;


// WEBPACK FOOTER //
// ./src/components/Organisation.js